import { createFileRoute, Navigate, redirect } from '@tanstack/react-router';

import { hasPermission } from '@shared/auth';

import { useAuthContext } from '@web/auth';
import { ContactTableView } from '@web/contacts/components';

export const Route = createFileRoute('/dashboard/admin/contact/list/')({
  beforeLoad({
    location,
    context: {
      auth: { user },
    },
  }) {
    if (user === null) {
      redirect({
        to: '/auth/sign-in',
        search: {
          returnTo: location.href,
        },
        throw: true,
      });
    }
  },
  component: View,
});

function View() {
  const { user } = useAuthContext();

  if (!user) return null;

  if (!hasPermission(user, 'contacts_module', 'access')) {
    return <Navigate to="/dashboard" />;
  }
  return <ContactTableView />;
}
